import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface RegistrationIconProps {
  color?: string
  size?: number
}

/**
 * Registration icon for competition setup wizard
 */
const RegistrationIcon: React.FC<RegistrationIconProps> = ({
  color = colors.PRIMARY,
  size = 40,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
    >
      <path d='M22.4999 6.6665H15.8333V13.3332H22.4999V6.6665Z' fill={color} />
      <path
        d='M12.4999 26.6665H5.83325V33.3332H12.4999V26.6665Z'
        fill={color}
      />
      <path
        d='M12.4999 16.6665H5.83325V23.3332H12.4999V16.6665Z'
        fill={color}
      />
      <path d='M12.4999 6.6665H5.83325V13.3332H12.4999V6.6665Z' fill={color} />
      <path d='M32.4999 6.6665H25.8333V13.3332H32.4999V6.6665Z' fill={color} />
      <path
        d='M17.4999 29.7665V33.3332H20.9999L30.9666 23.3832L27.4333 19.8498L17.4999 29.7665Z'
        fill={color}
      />
      <path
        d='M22.4999 20.0498V16.6665H15.8333V23.3332H19.2166L22.4999 20.0498Z'
        fill={color}
      />
      <path
        d='M33.9166 19.2665L31.5666 16.9165C31.2333 16.5832 30.7166 16.5832 30.3833 16.9165L28.6166 18.6832L32.1499 22.2165L33.9166 20.4498C34.2499 20.1165 34.2499 19.5998 33.9166 19.2665Z'
        fill={color}
      />
    </svg>
  )
}

export default RegistrationIcon
